module.exports = __webpack_public_path__ + "static/media/corner-triangle.5e00af4b.svg";